export const gerarDiasDaSemana = (
  inicio: Date
): { label: string; numero: number; dia: string; data: Date }[] => {
  const dias = [];
  const diasDaSemanaLabel = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ];
  for (let i = 0; i < 6; i++) {
    const novaData = new Date(inicio);
    novaData.setDate(inicio.getDate() + i);
    dias.push({
      label: diasDaSemanaLabel[novaData.getDay()],
      numero: novaData.getDay(),
      dia: novaData.getDate().toString().padStart(2, "0"),
      data: novaData,
    });
  }
  return dias;
};
